import envelopesFields from '../../../fields/envelopesFields';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Badge } from '@/common-utils/components/ui/badge';
import ENVELOPE_STATUS from '../../../enums/EnvelopeStatus';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';

export const columnsEnvelopesId = 'envelopes';

export const columnsEnvelopes = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsEnvelopesId, headerPackage.singleSelection),
        generateColumnDefByField({
            field: envelopesFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(envelopesFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = ENVELOPE_STATUS[cell.getValue()];
                return (
                    status &&
                    <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: envelopesFields.SENT_TO_TERMINAL_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(envelopesFields.SENT_TO_TERMINAL_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.POS_TERMINAL_SERIAL_NUMBER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={cell.getValue(envelopesFields.POS_TERMINAL_SERIAL_NUMBER.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.CLIENT_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: envelopesFields.SCHEDULED_START_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(envelopesFields.SCHEDULED_START_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.SCHEDULED_END_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(envelopesFields.SCHEDULED_END_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.ACCESS_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={cell.getValue(envelopesFields.ACCESS_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: envelopesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT,
            headerPackage: headerPackage
        })
    ]).filter(col => !!col);
};